export enum StreamType {
  Standard = 'std',
  Accelerated = 'acc',
  Holiday = 'hol',
}

export const STREAM_TYPE_LABELS: Record<StreamType, string> = {
  [StreamType.Standard]: 'Standard',
  [StreamType.Accelerated]: 'Accelerated',
  [StreamType.Holiday]: 'Holiday',
};
